import moment from 'moment-timezone'

import { CURRENT_TAX_YEAR, TAX_YEAR_END_DAY, TAX_YEAR_END_MONTH } from '@/constants'

const dateFormat = 'YYYY-MM-DD'

export const isCloseToDeadline = (offset = 7) => {
    const month = new Date().getMonth() + 1

    if (month !== 1) return false

    const day = new Date().getDate()
    const daysFromDeadline = 31 - day

    return daysFromDeadline <= offset
}

/** @returns 1 Jan */
export const formatDateWithoutYear = (dateTimeUTC) =>
    moment.tz(moment.utc(dateTimeUTC), 'Europe/London').format('D MMM')

/** @returns 1 Jan 2000 */
export const formatDate = (dateTimeUTC) => {
    if (!dateTimeUTC) return null
    return moment.tz(moment.utc(dateTimeUTC), 'Europe/London').format('D MMM YYYY')
}

/** @returns 1 January 2000 */
export const formatDateLong = (dateTimeUTC) => moment.tz(moment.utc(dateTimeUTC), 'Europe/London').format('D MMMM YYYY')

/** @returns 1 January 2000 12:00 */
export const formatDateWithTime = (dateTimeUTC) => {
    if (!dateTimeUTC) return null
    return moment.tz(moment.utc(dateTimeUTC), 'Europe/London').format('D MMMM YYYY HH:mm')
}

/** @returns 1 Jan 2000 12:00 */
export const formatShortDateWithTime = (dateTimeUTC) => {
    if (!dateTimeUTC) return null
    return moment.tz(moment.utc(dateTimeUTC), 'Europe/London').format('D MMM YYYY HH:mm')
}

export const formatDateFromNow = (dateTimeUTC) => (dateTimeUTC ? moment.utc(dateTimeUTC).fromNow() : dateTimeUTC)

export const formatTaxYear = (taxYear) => `${taxYear - 1}/${String(taxYear).slice(-2)}`

export const formatTaxYearDateRange = (year) => `6 Apr ${year - 1} – 5 Apr ${year}`

export const dateDifference = (date1, date2 = new Date()) => {
    const d1 = moment(date1)
    const d2 = moment(date2)
    const difference = d1.diff(d2, 'days')

    return difference
}

export const isDatePast = (dateToCheck) => {
    const d1 = moment(dateToCheck)
    const now = moment()

    if (now >= d1) {
        return true
    }

    return false
}

export const isDateWithinCurrentTaxYear = (enteredDate) =>
    isFirstDatePassedSecondDate(`${CURRENT_TAX_YEAR}-${TAX_YEAR_END_MONTH}-${TAX_YEAR_END_DAY}`, enteredDate)

export const isFirstDatePassedSecondDate = (firstDate, secondDate) => {
    const d1 = moment(firstDate)
    const d2 = moment(secondDate)

    if (!d1.isValid() || !d2.isValid()) return false

    if (d1 >= d2) {
        return true
    }

    return false
}

export const isBetweenDates = (dateToCheck, dateStart, dateEnd) => {
    if (!dateToCheck || !dateStart || !dateEnd) return false

    const d1 = moment(dateToCheck)
    const dStart = moment(dateStart)
    const dEnd = moment(dateEnd)

    if (!d1.isValid() || !dStart.isValid() || !dEnd.isValid()) return false

    if (d1 >= dStart && d1 <= dEnd) {
        return true
    }

    return false
}

export const isDateOverLimit = (dateToCheck, dayLimit) => {
    const d1 = moment(dateToCheck)
    const now = moment()
    const difference = d1.diff(now, 'days')

    if (now > d1) {
        return false
    }

    if (dayLimit - 1 <= difference) {
        return true
    }

    return false
}

export const isTodayWeekend = () => {
    const today = new Date()

    return today.getDay() === 6 || today.getDay() === 0
}

export const isTaxYearEnded = (taxYear) => isDatePast(moment(`${taxYear}-${TAX_YEAR_END_MONTH}-${TAX_YEAR_END_DAY}`))

export const formatDateQuery = (date) => (date ? moment(date).format(dateFormat) : date)

export const getDate = (date = moment()) => moment(date, dateFormat)

export const getYear = (date = getDate()) => getDate(date).year()

export const getMonth = (date = getDate()) => getDate(date).month() + 1
